import {toastController} from '@ionic/vue';

export default {
    install: (app) => {

        const toast = function(message, options = {}, colour = null) {
            const defaults = {
                duration: 3000,
                color: colour?colour:'primary',
                header: null,
                message,
                buttons: [{
                    text: 'Done'
                }]
            };

            options = {...defaults, ...options};
            return toastController.create(options).then(toast => {
                console.log(options);
                return toast.present();
            })
        }

        app.provide('$toast', {
            danger(message, options) {
                return toast(message, options, 'danger');
            },
            success(message, options) {
                return toast(message, options, 'success');
            },
            warning(message, options) {
                return toast(message, options, 'warning');
            }
        });
    }
}
